/*
  Solvik — la barre d'achat fixe (voir snippets/solvik-achat-fixe.liquid).
  Sous 750 px seulement : au-dessus, le bouton est déjà à l'écran au chargement.
*/
(function () {
  var barre = document.querySelector('[data-sv-achat-fixe]');
  if (!barre || !('IntersectionObserver' in window)) return;
  var vrai = document.getElementById(barre.dataset.bouton);
  if (!vrai) return;
  var copie = barre.querySelector('button');
  var mobile = window.matchMedia('(max-width: 749px)');

  document.body.appendChild(barre);

  // Le libellé et l'état viennent du vrai bouton, que le calculateur réécrit
  // à chaque surface saisie (« Ajouter au panier · 1 855,55 € »).
  function recopier() {
    var span = vrai.querySelector('span');
    copie.textContent = (span ? span.textContent : vrai.textContent).trim();
    copie.disabled = vrai.disabled || vrai.getAttribute('aria-disabled') === 'true';
  }
  recopier();
  new MutationObserver(recopier).observe(vrai, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true,
  });

  copie.addEventListener('click', function () {
    vrai.click();
  });

  // Les zones où la barre doit se taire : le vrai bouton, le pack, le pied.
  var visibles = new Set();
  var zones = [vrai, document.querySelector('.sv-pack'), document.querySelector('footer, .footer')];

  function decider() {
    barre.hidden = !mobile.matches || visibles.size > 0;
  }

  var observateur = new IntersectionObserver(function (entrees) {
    entrees.forEach(function (e) {
      if (e.isIntersecting) visibles.add(e.target);
      else visibles.delete(e.target);
    });
    decider();
  });
  zones.forEach(function (z) {
    if (z) observateur.observe(z);
  });
  mobile.addEventListener('change', decider);
})();
